import { apiFetch } from '~/utils/apiFetch'
import type { HomeApiData } from '~/pages/index/types/home-aggregate'

export interface FetchHomeParams {
  section_limit?: number
}

/** GET /api/v1/home — 游戏首页聚合（公告/轮播/大奖/分类/推荐等） */
export function fetchHome(params?: FetchHomeParams) {
  return apiFetch<HomeApiData>('/home', {
    query: {
      section_limit: params?.section_limit ?? 10,
    },
  })
}
